class ZerraProductsSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('[data-products-track]');
    this.slides = [...el.querySelectorAll('[data-products-slide]')];
    this.prevBtn = el.closest('.zerra-products')?.querySelector('[data-products-prev]') || el.querySelector('[data-products-prev]');
    this.nextBtn = el.closest('.zerra-products')?.querySelector('[data-products-next]') || el.querySelector('[data-products-next]');
    this.dotsRoot = el.closest('.zerra-products')?.querySelector('[data-products-dots]');
    this.progress = el.closest('.zerra-products')?.querySelector('[data-products-progress]');
    this.dots = [];
    this.index = 0;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.track || this.slides.length < 2) {
      el.classList.add('is-static');
      this.buildDots();
      this.syncChrome();
      return;
    }

    this.prevBtn?.addEventListener('click', () => this.go(this.index - 1));
    this.nextBtn?.addEventListener('click', () => this.go(this.index + 1));

    this.bindDrag();
    this.bindKeys();
    this.buildDots();

    window.addEventListener('resize', () => {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        this.buildDots();
        this.go(this.index, false);
      }, 120);
    });

    this.go(0, false);
  }

  perView() {
    const w = window.innerWidth;
    if (w >= 1100) return 3;
    if (w >= 750) return 2;
    return 1;
  }

  maxIndex() {
    return Math.max(0, this.slides.length - this.perView());
  }

  buildDots() {
    if (!this.dotsRoot) return;
    const pages = this.maxIndex() + 1;
    this.dotsRoot.innerHTML = '';

    if (pages <= 1) {
      this.dotsRoot.hidden = true;
      this.dots = [];
      return;
    }

    this.dotsRoot.hidden = false;
    for (let i = 0; i < pages; i += 1) {
      const li = document.createElement('li');
      li.setAttribute('role', 'presentation');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zerra-products__dot' + (i === this.index ? ' is-active' : '');
      btn.setAttribute('data-products-dot', '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-label', `Vai al gruppo ${i + 1}`);
      btn.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
      btn.addEventListener('click', () => this.go(i));
      li.appendChild(btn);
      this.dotsRoot.appendChild(li);
    }
    this.dots = [...this.dotsRoot.querySelectorAll('[data-products-dot]')];
  }

  go(next, animate = true) {
    const max = this.maxIndex();
    this.index = Math.min(Math.max(next, 0), max);

    const slide = this.slides[this.index];
    if (!slide) return;

    // offset rispetto al track interno (contenuto scrollabile)
    const scroller = this.track;
    const left = slide.offsetLeft;

    scroller.scrollTo({
      left,
      behavior: animate && !this.reduceMotion ? 'smooth' : 'auto',
    });
    this.syncChrome();
  }

  syncChrome() {
    const max = this.maxIndex();
    if (this.prevBtn) this.prevBtn.disabled = this.index <= 0 || max === 0;
    if (this.nextBtn) this.nextBtn.disabled = this.index >= max || max === 0;

    this.dots.forEach((dot, i) => {
      const active = i === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (this.progress) {
      const total = Math.max(1, max + 1);
      this.progress.style.width = `${((this.index + 1) / total) * 100}%`;
    }

    this.slides.forEach((slide, i) => {
      const inView = i >= this.index && i < this.index + this.perView();
      slide.classList.toggle('is-in-view', inView);
    });
  }

  bindKeys() {
    this.el.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.go(this.index - 1);
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.go(this.index + 1);
      }
    });
  }

  bindDrag() {
    let startX = 0;
    let startScroll = 0;
    let dragging = false;

    const onDown = (e) => {
      dragging = true;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      startScroll = this.track.scrollLeft;
      this.el.classList.add('is-dragging');
    };

    const onMove = (e) => {
      if (!dragging) return;
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      this.track.scrollLeft = startScroll - (x - startX);
    };

    const onUp = (e) => {
      if (!dragging) return;
      dragging = false;
      this.el.classList.remove('is-dragging');
      const x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
      const delta = x - startX;
      if (Math.abs(delta) > 48) {
        this.go(this.index + (delta < 0 ? 1 : -1));
      } else {
        this.go(this.index);
      }
    };

    this.track.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    this.track.addEventListener('touchstart', onDown, { passive: true });
    this.track.addEventListener('touchmove', onMove, { passive: true });
    this.track.addEventListener('touchend', onUp);
  }
}

function initZerraProductsSliders(root = document) {
  root.querySelectorAll('[data-products-slider]:not([data-products-init])').forEach((el) => {
    el.setAttribute('data-products-init', 'true');
    new ZerraProductsSlider(el);
  });
}

document.addEventListener('DOMContentLoaded', () => initZerraProductsSliders());
document.addEventListener('shopify:section:load', (e) => initZerraProductsSliders(e.target));
